import { gql } from "@apollo/client";

export const SAVE_PROCEDIMIENTO_CP = gql`
mutation SaveProcedimientoCP($input: AddVisitaPresencialCPProcedimientoInput!) {
    saveVisitaPresencialCPProcedimiento(input: $input) {
        idPresencialCPCD
    }
}`;

export default SAVE_PROCEDIMIENTO_CP;

export const adaptAddPresencialProcedimientoCPInput = (data) => ({
  idPresencialCPCD: data.idPresencialCPCD,
  controlSignosVitales: !!data.controlSignosVitales,
  justifSinSignos: data.justifSinSignos,
  tensionArterial: data.tensionArterial,
  temperatura: data.temperatura,
  frecuenciaRespiratoria: data.frecuenciaRespiratoria,
  sPO2: data.spo2,
  frecuenciaCardiaca: data.frecuenciaCardiaca,
  cambioSondaVesical: !!data.cambioSondaVesical,
  aspiracionSecreciones: !!data.aspiracionSecreciones,
  curacionLesiones: !!data.curacionLesiones,
  adminMedicamentos: !!data.adminMedicamentos,
  otros: data.otros,
  idVisita: data.idVisita
});